import { OrderImport } from '../../../components';

const OrderImportPage = () => {
  return <OrderImport mode="page" />;
};

export default OrderImportPage;
